"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviousIconButton = exports.Popover = exports.NextIconButton = exports.Input = exports.ButtonsWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _GhostIconButton = _interopRequireDefault(require("../Buttons/GhostIconButton"));
var _Popover = _interopRequireDefault(require("../Tooltips/Popover"));
var _InputParts = require("../Inputs/InputParts");
var _IconButton = require("../Buttons/IconButton");
var _excluded = ["name", "label", "width"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var widthButtonPrev = "20px";
var widthButtonNext = "28px";
var ButtonsWrapper = (0, _styledComponents["default"])(_InputParts.PointerEventsReset).withConfig({
  displayName: "DateParts__ButtonsWrapper",
  componentId: "sc-zby2r6-0"
})(["display:flex;justify-content:center;align-items:center;position:absolute;top:0;right:0;height:100%;"]);
exports.ButtonsWrapper = ButtonsWrapper;
var Popover = function Popover(props) {
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], _extends({
    triggerW: "auto"
  }, props));
};
exports.Popover = Popover;
var PreviousIconButton = function PreviousIconButton(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? "ChevronLeft" : _ref$name,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Previous" : _ref$label,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? widthButtonPrev : _ref$width,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_GhostIconButton["default"], _extends({
    name: name,
    label: label,
    w: width,
    h: "fieldsHeight",
    iconSize: "base",
    color: "inputButton"
  }, rest));
};
exports.PreviousIconButton = PreviousIconButton;
PreviousIconButton.propTypes = _IconButton.propTypes;
var NextIconButton = function NextIconButton(props) {
  return /*#__PURE__*/_react["default"].createElement(PreviousIconButton, _extends({
    name: "ChevronRight",
    label: "Next",
    w: widthButtonNext
  }, props));
};

// leave Input at the end because it messes up code coloring in VS code :)
exports.NextIconButton = NextIconButton;
var Input = (0, _styledComponents["default"])(_InputParts.StyledInput).attrs(function (props) {
  return {
    variant: props.variant || props.theme.fields.inputVariant
  };
}).withConfig({
  displayName: "DateParts__Input",
  componentId: "sc-zby2r6-1"
})(["position:relative;display:flex;flex-direction:row;cursor:pointer;", ";"], function (props) {
  return props.hasPrevNextButtons && (0, _styledComponents.css)(["padding-right:calc( ", " + ", " + ", " );"], widthButtonPrev, widthButtonNext, props.theme.spaces.xs);
});
exports.Input = Input;